var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgErrorComputer = function SvgErrorComputer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 100,
    viewBox: "0 0 201 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1488_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.56951 92.5028C-5.64439 82.8943 4.21219 57.1878 19.0767 41.4671C37.1524 22.3544 62.0702 6.27705 110.238 11.7444C150.012 16.2612 174.705 36.0671 183.104 46.2677C196.46 62.4814 206.11 85.3588 198.066 94.8203C184.567 110.702 128.795 83.6798 98.5425 83.129C68.2904 82.5782 24.1473 113.923 3.56951 92.5028Z",
    fill: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.496 77.1523H41.5101L19.4279 5.87931C19.2166 5.19871 19.1701 4.47865 19.2922 3.77708C19.4143 3.07552 19.7016 2.41205 20.131 1.84009C20.5604 1.26813 21.1198 0.803652 21.7642 0.484051C22.4087 0.16445 23.1202 -0.00134631 23.8414 8.23349e-06H119.183C120.17 -7.66335e-05 121.131 0.312674 121.924 0.892203C122.718 1.47173 123.301 2.28741 123.59 3.21911L146.496 77.1523Z",
    fill: "#BABACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.303 68.6675H53.9839C52.9879 68.6673 52.0182 68.3517 51.2174 67.7671C50.4167 67.1825 49.8271 66.3598 49.5353 65.4199L32.8132 11.4447C32.7068 11.1022 32.6832 10.7399 32.7445 10.3868C32.8057 10.0338 32.9501 9.69982 33.166 9.41186C33.3818 9.12391 33.6632 8.88998 33.9874 8.72891C34.3116 8.56784 34.6695 8.48412 35.0324 8.48449H110.35C111.346 8.48467 112.316 8.80025 113.117 9.38483C113.918 9.96941 114.507 10.7921 114.799 11.7321L131.522 65.7073C131.628 66.0497 131.652 66.412 131.59 66.7651C131.529 67.1182 131.385 67.4521 131.169 67.7401C130.953 68.028 130.672 68.262 130.347 68.423C130.023 68.5841 129.665 68.6678 129.302 68.6675H129.303Z",
    fill: "#5B5D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5101 77.1519H182.53C183.001 77.152 183.467 77.2437 183.902 77.4217C184.338 77.5997 184.733 77.8606 185.066 78.1895C185.399 78.5183 185.663 78.9087 185.844 79.3383C186.024 79.768 186.117 80.2284 186.117 80.6934V85.4241C186.116 86.363 185.738 87.2633 185.066 87.9272C184.393 88.5911 183.481 88.9641 182.53 88.9643H45.097C44.1458 88.9641 43.2335 88.5911 42.5609 87.9272C41.8883 87.2633 41.5103 86.363 41.5101 85.4241V77.1519Z",
    fill: "#5B5D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6971 41.1742L67.2743 31.7243",
    stroke: "#BABACA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.299 41.1742L56.3828 31.7243",
    stroke: "#BABACA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.051 41.1742L109.628 31.7244",
    stroke: "#BABACA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.654 41.1742L98.735 31.7243",
    stroke: "#BABACA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8514 47.149C79.8514 47.149 86.575 43.4891 93.4041 47.149",
    stroke: "#BABACA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28 35.9946C152.502 35.9927 151.749 35.7285 151.144 35.2459C150.539 34.7632 150.12 34.0911 149.955 33.3409C149.323 30.5276 148.922 28.3794 149.48 26.37C150.15 23.9871 151.916 22.592 153.819 21.2567C155.102 20.359 155.993 18.9965 156.092 17.7888C156.121 17.3909 156.055 16.9918 155.899 16.6239C155.743 16.2559 155.501 15.9295 155.193 15.6709C153.197 13.7593 149.966 16.7337 149.821 16.8622C149.821 16.8622 147.106 19.1308 145.089 16.7522C143.072 14.3735 145.089 12.0153 145.089 12.0153C146.39 10.8228 147.887 9.85706 149.516 9.15929C153.398 7.52563 157.096 8.1376 159.932 10.8405C160.958 11.7894 161.756 12.9532 162.266 14.2463C162.777 15.5394 162.988 16.929 162.883 18.313C162.633 21.5321 160.719 24.6923 157.757 26.7596C156.366 27.7328 156.104 28.0774 156.039 28.1878C155.88 28.6855 156.405 31.0173 156.603 31.8966C156.713 32.3882 156.71 32.8978 156.594 33.3881C156.479 33.8784 156.253 34.3369 155.934 34.7299C155.616 35.1229 155.212 35.4405 154.752 35.6593C154.293 35.8782 153.79 35.9928 153.28 35.9946Z",
    fill: "#9799A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.923 47.6674C157.106 47.6674 158.875 45.9202 158.875 43.7648C158.875 41.6095 157.106 39.8622 154.923 39.8622C152.74 39.8622 150.97 41.6095 150.97 43.7648C150.97 45.9202 152.74 47.6674 154.923 47.6674Z",
    fill: "#9799A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1488_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 100,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorComputer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-computer.8c0ae88c.svg";
export { ForwardRef as ReactComponent };